import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Vacations } from '../../classes/vacations';
import { VacationsService } from '../../services/vacations.service';
import { CompanyService } from '../../services/company.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UserService } from '../../../shared/services/user.service';

@Component({
  selector: 'app-time-off-policies-page',
  templateUrl: './time-off-policies-page.component.html',
  styleUrls: ['./time-off-policies-page.component.scss']
})
export class TimeOffPoliciesPageComponent implements OnInit {
  vacations: Vacations = <Vacations>{
    paid_out_vaction: false,
    accrue_vacation_in_dollars: false,
    accrue_vacation_in_hours: false
  }
  @ViewChild('childModal') public childModal: ModalDirective;
  sub: any;
  orgId: number;
  isAdmin: boolean;
  incomplete: boolean;
  error: string;
  steps: any[] = [];

  constructor(
    private VacationsService: VacationsService,
    private CompanyService: CompanyService,
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title,
    private UserService: UserService
  ) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.orgId = +params['orgId'];
      this.getVacations();
      this.getCompany();
    })

    this.UserService.getUserInfo()
      .subscribe(user => {
        console.log(user)
        let u: any = JSON.parse(user.user);
        this.isAdmin = u.admin;
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
    this.titleService.setTitle('Time Off Policies');
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  displayError() {
    let steps = this.steps
      .filter(s => {
        return !s[2]
      }).map(s => {
        return s[0]
      }).join(', ');
    this.error = `Please complete the following steps before clicking Complete: ${steps}`;
  }

  getCompany() {
    this.CompanyService.getCompany(this.orgId)
      .subscribe(org => {
        this.steps = JSON.parse(org.steps);
        this.incomplete = this.steps.slice(0, 4).some(s => {
          return !s[2];
        });
        if (this.incomplete) {
          this.router.navigate(['/onboarding/upload/', this.orgId, 1])
        }
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  getVacations() {
    this.VacationsService.getVacations(this.orgId)
      .subscribe(vacations => {
        this.vacations = JSON.parse(vacations.vacation || '{}');
      })
  }

  public showChildModal(): void {
    this.childModal.show();
  }

  public hideChildModal(): void {
    this.childModal.hide();
  }

  saveVacation() {


    if (this.vacations.id) {
      this.VacationsService.editVacation(this.orgId, this.vacations.id, this.vacations)
        .subscribe(vacations => {
          this.getVacations();
        }, err => {
          console.log(err)
          if (err.status == 401) {
            localStorage.clear();
            this.router.navigate(['/']);
          }
        })
    }
    else {
      this.VacationsService.addVacation(this.orgId, this.vacations)
        .subscribe(vacations => {
          this.getVacations();
        }, err => {
          console.log(err)
          if (err.status == 401) {
            localStorage.clear();
            this.router.navigate(['/']);
          }
        })
    }

    let missingSteps = this.steps
      .filter(s => {
        return !s[2] && s[0] != 'Setup your Vacation Policies';
      }).length > 0;

    let steps = this.steps
      .filter(s => {
        return !s[2] && s[0] != 'Setup your Vacation Policies';
      }).map(s => {
        return s[0]
      }).join(', ');

    if (missingSteps) {
      this.error = `Please complete the following steps before changing settings: ${steps}`;
    }

  }

  setPaidOutVacation(val: boolean) {
    if (!this.isAdmin) {
      this.vacations.paid_out_vaction = val;
    }
  }

  setAccrueDollar(val: boolean) {
    if (!this.isAdmin) {
      this.vacations.accrue_vacation_in_dollars = val;
    }
  }

  setAccrueVacation(val: boolean) {
    if (!this.isAdmin) {
      this.vacations.accrue_vacation_in_hours = val;
    }
  }

  complete() {
    this.vacations.paid_out_vaction = !!this.vacations.paid_out_vaction;
    this.vacations.accrue_vacation_in_dollars = !!this.vacations.accrue_vacation_in_dollars;
    this.vacations.accrue_vacation_in_hours = !!this.vacations.accrue_vacation_in_hours;
    if (this.vacations.id) {
      this.VacationsService.editVacation(this.orgId, this.vacations.id, this.vacations)
        .subscribe(() => {
           this.trackSegmentEvent();
           this.router.navigate(['/onboarding/submit', this.orgId]);
        })
    } else {
      this.VacationsService.addVacation(this.orgId, this.vacations)
        .subscribe(() => {
          this.trackSegmentEvent();
          this.router.navigate(['/onboarding/submit', this.orgId]);
        })
    }
  }

  trackSegmentEvent() {
    if(!this.isAdmin) window.analytics.track("Self-Signup Time Off Policies Added", {
      OrgId: this.orgId, 
      paidOutVaction: this.vacations.paid_out_vaction, 
      AccrueVacationInDollars: this.vacations.accrue_vacation_in_dollars, 
      AccrueVacationInHours: this.vacations.accrue_vacation_in_hours
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/time-off-policies-page/time-off-policies-page.component.ts